import React from 'react';



function TestimonialsPage() {
    return (
        <div className='bg-color'>


            <section className="pt-5 pb-5">
                <div className="container">
                    <div className="section-title" dataAos="fade-up">
                        <h1 className='text-center'><span className='wordcircle-white'>Testimonials</span></h1>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <h3 className="mb-5 text-center"><span className='wordcircle-white'>What people say</span></h3>
                            {/* <p className="mb-5 text-center">Masonry testimonial cards grid</p> */}
                        </div>
                        <div className="col-12 col-md-4">
                            <div className="card-columns">

                                <div className="card mb-4">
                                    <div className="card-body">
                                        <blockquote className=" ">
                                            <i className="fa fa-quote-right fa-2x text-muted pull-right mt-3 mb-3" aria-hidden="true"></i>
                                            {/* <h5>A Caregiver Who Truly Understands</h5> */}
                                            <p className="m-0 text-muted ">
                                                I just started bringing my 2 children here, and I am beyond impressed! This daycare is clean, very organized, and you can just tell the staff takes great care in ensuring the place is safe and inviting for children. Both my kids had a wonderful time. They came home smiling and telling me stories. They even taught me a couple of things they learned that day. I appreciate this environment they are in. Where they are not only entertained, but encouraged to grow and learn. Also, Amber (the owner) is AMAZING!!!! Definitely recommend and will be bringing my kids back soon.
                                            </p>
                                        </blockquote>
                                        <figcaption className="blockquote-footer">
                                            Shaytra Ewell
                                        </figcaption>
                                    </div>
                                </div>


                                <div className="card mb-4">
                                    <div className="card-body">
                                        <blockquote className=" ">
                                            <i className="fa fa-quote-right fa-2x text-muted pull-right mt-3 mb-3" aria-hidden="true"></i>
                                            <h5>A Caregiver Who Truly Understands</h5>
                                            <p className="m-0 text-muted ">
                                                Amber has been an incredible influence on my child's growth. My little one struggled with social interactions, but under Amber's care, I've seen such a positive transformation. Her patience and creativity make every activity engaging, and her ability to connect with kids on a personal level is unmatched. Amber's dedication gave my child the confidence and skills they needed to thrive.
                                            </p>
                                        </blockquote>
                                        <figcaption className="blockquote-footer">
                                            Kim S
                                        </figcaption>
                                    </div>
                                </div>
                                <div className="card mb-4">
                                    <div className="card-body">
                                        <blockquote className=" ">
                                            <i className="fa fa-quote-right fa-2x text-muted pull-right mt-3 mb-3" aria-hidden="true"></i>
                                            <h5>A Caregiver Who Transforms Lives</h5>
                                            <p className="m-0 text-muted ">
                                                Amber has a remarkable ability to connect with children and help them thrive. Watching my kids grow socially and academically under her care was nothing short of amazing. Her thoughtful and personalized approach ensured that each of my children felt understood and supported. Amber's genuine passion for childcare shines through in everything she does.
                                            </p>
                                        </blockquote>
                                        <figcaption className="blockquote-footer">
                                            Tierra K
                                        </figcaption>
                                    </div>
                                </div>


                            </div>
                        </div>
                        <div className="col-12 col-md-4">
                            <div className="card mb-4">
                                <div className="card-body">
                                    <blockquote className=" ">
                                        <i className="fa fa-quote-right fa-2x text-muted pull-right mt-3 mb-3" aria-hidden="true"></i>
                                        {/* <h5>A Caregiver Who Truly Understands</h5> */}
                                        <p className="m-0 text-muted ">
                                            Later Tots is such an amazing experience. Not just for the kids but for parents too. The kids have a great time and learn while they play. This also gives parents a much needed break to recharge. Amber (the owner) is AMAZING! The kids love her and she has such a passion for kids. Her background in childcare and early childhood development is a plus! My kids absolutely love her and enjoy every minute of it. This is an experience you and your kids must try. You won't regret it and the kids will be begging to go back for more. This a much needed service and gem for the Concord area. Highly recommend giving it a try!
                                        </p>
                                    </blockquote>
                                    <figcaption className="blockquote-footer">
                                        Shenna Shaw
                                    </figcaption>
                                </div>
                            </div>
                            <div className="card mb-4">
                                <div className="card-body">
                                    <blockquote className=" ">
                                        <i className="fa fa-quote-right fa-2x text-muted pull-right mt-3 mb-3" aria-hidden="true"></i>
                                        <h5>Amber is the difference</h5>
                                        <p className="m-0 text-muted ">
                                            I highly recommend Amber—she stands out from the rest. As a parent of two children with different ages and personalities, I saw significant improvements in both their academics and social skills in such a short time. Amber is incredibly patient and gives each of my kids the individual attention they need. Her genuine passion for working with children makes learning fun and engaging for them, and that puts me at ease as a parent. Knowing she truly cares made all the difference.
                                        </p>

                                    </blockquote>
                                    <figcaption className="blockquote-footer">
                                        Amber W
                                    </figcaption>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-4">
                            <div className="card mb-4">
                                <div className="card-body">
                                    <blockquote className=" ">
                                        <i className="fa fa-quote-right fa-2x text-muted pull-right mt-3 mb-3" aria-hidden="true"></i>
                                        {/* <h5>A Caregiver Who Truly Understands</h5> */}
                                        <p className="m-0 text-muted ">
                                            I had such a positive experience with this amazing drop-in center! The staff was welcoming, attentive, and made sure my child felt safe and comfortable right away. The facility was clean, organized, and had plenty of age-appropriate toys and activities to keep the kids engaged. I also appreciated the flexible hours, which made it easy for me to run errands without worrying. Most importantly, my child left happy and excited to return. I highly recommend this center to any parent looking for a safe, caring, and reliable place for their little one.
                                        </p>
                                    </blockquote>
                                    <figcaption className="blockquote-footer">
                                        Jasmine
                                    </figcaption>
                                </div>
                            </div>
                            <div className="card mb-4">
                                <div className="card-body">
                                    <blockquote className=" ">
                                        <i className="fa fa-quote-right fa-2x text-muted pull-right mt-3 mb-3" aria-hidden="true"></i>
                                        <h5>Gifted and Caring</h5>
                                        <p className="m-0 text-muted ">
                                            Amber's natural talent for working with children is evident in the positive changes I've seen in my kids. She has a knack for understanding their unique needs and helping them blossom in ways I never imagined. Whether it's learning new skills or building confidence, Amber creates a warm and engaging environment that makes all the difference.


                                        </p>
                                    </blockquote>
                                    <figcaption className="blockquote-footer">
                                        Nicole B
                                    </figcaption>
                                </div>
                            </div>
                            <div className="card mb-4">
                                <div className="card-body">
                                    <blockquote className=" ">
                                        <i className="fa fa-quote-right fa-2x text-muted pull-right mt-3 mb-3" aria-hidden="true"></i>
                                        <h5>Amber Makes Learning Fun!</h5>
                                        <p className="m-0 text-muted ">
                                            I can't recommend Amber enough! She has a gift for making learning exciting and engaging for kids. Both of my children, despite their differences in age and personality, saw significant improvements in their academics and social skills. Amber’s patient approach and true passion for what she does are what set her apart.
                                        </p>
                                    </blockquote>
                                    <figcaption className="blockquote-footer">
                                        Stacy A
                                    </figcaption>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default TestimonialsPage;